import FeedEmptyView from './FeedEmptyView';

export default FeedEmptyView;
